module.exports = __webpack_public_path__ + "img/toxis_main.bc336edd.png";